const regimeApuracaoTributaria = {
  REGIME_SN_TOTAL: '1 - Regime de apuração dos tributos federais e municipal pelo SN',
  REGIME_SN_FEDERAL_ISS_FORA:
    '2 - Regime de apuração dos tributos federais pelo SN e ISSQN por fora do SN conforme respectiva legislação municipal do tributo',
  REGIME_FORA_SN_TOTAL:
    '3 - Regime de apuração dos tributos federais e municipal por fora do SN conforme respectivas legislações federal e municipal de cada tributo',
};

export default regimeApuracaoTributaria;
